import { shellPaths } from '@/core/router/app-paths';

const RETURN_TO_PARAM = 'returnTo';

/** Shell pages only; never the create page itself or an external URL. */
function isReturnablePath(path: string): boolean {
  return (
    path.startsWith('/tabs/') &&
    !path.startsWith('//') &&
    !path.startsWith(shellPaths.moreWorkspaceCreate)
  );
}

/**
 * Create-workspace link that remembers where it was opened. In the browser
 * the shell replaces history entries, so „Abbrechen“ could not go back and
 * always landed on the status board (DEV-574).
 */
export function workspaceCreatePath(fromPath: string): string {
  if (!isReturnablePath(fromPath)) return shellPaths.moreWorkspaceCreate;
  const query = new URLSearchParams({ [RETURN_TO_PARAM]: fromPath });
  return `${shellPaths.moreWorkspaceCreate}?${query.toString()}`;
}

export function readWorkspaceCreateReturnTo(search: string): string | null {
  const value = new URLSearchParams(search).get(RETURN_TO_PARAM);
  return value && isReturnablePath(value) ? value : null;
}
